import React from 'react';
import transportFieldsConnect from '../../common/hoc/transportFieldsConnect';
import employeesConnect from '../../../../../common/hoc/employeesConnect';
import filterConnect from '../../../../../common/hoc/filterConnect';

const Main = transportFieldsConnect(
  ({ getDescription, fieldsValue, brandsTypes }) => {
    let val = getDescription(fieldsValue, { brandsTypes });
    return val ? val : null;
  },
  ['brandsTypes']
);

const Parking = transportFieldsConnect(
  ({ getDescription, fieldsValue, parkingTypes }) => {
    let val = getDescription(fieldsValue, { parkingTypes });
    return val ? val : null;
  },
  ['parkingTypes']
);

const FixedDrivers = employeesConnect(
  ({ getDescription, fieldsValue, profiles }) => {
    let val = getDescription(fieldsValue, { profiles });
    return val ? val : null;
  },
  ['driver']
);

const Limitations = filterConnect(
  ({ getDescription, fieldsValue, serviceTypes }) => {
    let val = getDescription(fieldsValue, { serviceTypes });
    return val ? val : null;
  },
  ['serviceTypes']
);

const progressDescription = ({ name, getDescription, fieldsValue }) => {
  if (!getDescription) return null;
  switch (name) {
    case 'main': return (
      <Main getDescription={getDescription} fieldsValue={fieldsValue} />
    );
    case 'parking': return (
      <Parking getDescription={getDescription} fieldsValue={fieldsValue} />
    );
    case 'fixedDrivers': return (
      <FixedDrivers getDescription={getDescription} fieldsValue={fieldsValue} />
    );
    case 'limitations': return (
      <Limitations getDescription={getDescription} fieldsValue={fieldsValue} />
    );
    case 'photoDriverLicense':
      return null;
    default:
      return getDescription(fieldsValue);
  }
};

export default progressDescription;
